<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">
          {{ 'shared.googleMaps.title' | translate }}
        </h4>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="close()"
        ></button>
      </div>

      <div class="modal-body">
        <div class="col-12">
          <div class="row">
            <input
              [placeholder]="'shared.googleMaps.addressPlaceholder' | translate"
              class="form-control mb-2 w-100"
              type="text"
              [matAutocomplete]="auto"
              [formControl]="addressControl"
            />

            <mat-autocomplete
              #auto="matAutocomplete"
              [displayWith]="displayAddress"
              (optionSelected)="onOptionSelected($event)"
            >
              @for (suggestion of filteredSuggestions$ | async; track
              suggestion) {
              <mat-option [value]="suggestion">
                {{ suggestion.formattedAddress }}
              </mat-option>
              }
            </mat-autocomplete>
            <google-map
              height="400px"
              width="100%"
              [center]="center"
              [zoom]="zoom"
              (mapClick)="addMarker($event)"
              (mapMousemove)="move($event)"
            >
              @for (position of markerPositions; track position) {
              <map-marker [position]="position" [options]="markerOptions" />
              }
            </google-map>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="close()">
          {{ 'shared.googleMaps.cancelButton' | translate }}
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          [mat-dialog-close]="true"
          (click)="send()"
        >
          {{ 'shared.googleMaps.selectButton' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
